// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cursor {
    cursor: pointer;
}

.my-groups h2 {
    font-weight: 700;
    font-size: 28px;
    color: #0f062b;
    padding: 5px 0 20px;
    margin-bottom: 0;
}

.group-box {
    padding: 30px;
    border-radius: 16px;
    background-color: #ffff;
}

.FF-scroll-modify {
    height: 800px;
}

.group-box .add-box {
    aspect-ratio: 16/9;
    position: relative;
    width: 100%;
    height: 230px;
    border: 2px solid #6c2fbb;;
    border-radius: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    cursor: pointer;
}

.group-box .add-box .plus {
    width: 28px;
    height: 26px;
    background: #F8FAFB;
    border-radius: 4px;
    text-align: center;
}

.group-box .add-box h5 {
    color: #6c2fbb;
}

.group-box h4 {
    font-weight: 400;
    padding: 10px 0 0 0;
    font-size: 18px;
}

.group-box .title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.group-box .col-xl-3 {
    margin-top: 30px;
}

.owner-dots {
    position: absolute;
    top: 0;
    left: 0;
    background-color: #727272;
    color: #fff;
    display: flex;
    cursor: initial;
    align-items: center;
    -moz-column-gap: 10px;
         column-gap: 10px;
    padding: 7px 14px;
    border-radius: 5px 0;
}

.dots {
    position: absolute;
    top: 0;
    right: 0;
    background-color: #727272;
    display: flex;
    cursor: pointer;
    align-items: center;
    -moz-column-gap: 10px;
         column-gap: 10px;
    padding: 7px 14px;
    border-radius: 0 5px;
}

.img-box {
    aspect-ratio: 16/9;
    cursor: pointer;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 200px;
    border-radius: 16px;
    overflow: hidden;
    position: relative;
    background: #f8f9fa;
}

.img-box img {
    object-fit: contain;
}

.tab-box-group {
    width: 100%;
    margin-top: 20px;
}

.tab-box-group ul {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
}

.tab-box-group ul li {
    list-style: none;
    font-weight: 500;
    font-size: 18px;
    padding: 5px 0;
    margin: 0px 25px;
    color: #878395;
    cursor: pointer;
}

.tab-box-group ul li.active {
    border-top: 3px solid rgba(108, 47, 187, 1);
    color: rgba(108, 47, 187, 1);
}

@media (max-width: 1500px) {
    .group-box h4 {
        font-size: 20px;
    }

    .img-box {
        height: 172px;
    }

    .group-box .add-box {
        height: 206px;
    }
}


@media (max-width: 768px) {
    .group-box {
        margin-top: 10px;
    }

    .group-box h4 {
        font-size: 18px;
    }

    .group-box {
        padding: 10px 10px;
        background-color: #ffff;
    }

    .add-box h5 {
        font-size: 18px;
    }

    .group-box .add-box {
        padding: 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/coupon/coupon.component.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,qBAAgB;SAAhB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,yBAAyB;IACzB,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,qBAAgB;SAAhB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,2CAA2C;IAC3C,4BAA4B;AAChC;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;;AAGA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".cursor {\n    cursor: pointer;\n}\n\n.my-groups h2 {\n    font-weight: 700;\n    font-size: 28px;\n    color: #0f062b;\n    padding: 5px 0 20px;\n    margin-bottom: 0;\n}\n\n.group-box {\n    padding: 30px;\n    border-radius: 16px;\n    background-color: #ffff;\n}\n\n.FF-scroll-modify {\n    height: 800px;\n}\n\n.group-box .add-box {\n    aspect-ratio: 16/9;\n    position: relative;\n    width: 100%;\n    height: 230px;\n    border: 2px solid #6c2fbb;;\n    border-radius: 16px;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    cursor: pointer;\n}\n\n.group-box .add-box .plus {\n    width: 28px;\n    height: 26px;\n    background: #F8FAFB;\n    border-radius: 4px;\n    text-align: center;\n}\n\n.group-box .add-box h5 {\n    color: #6c2fbb;\n}\n\n.group-box h4 {\n    font-weight: 400;\n    padding: 10px 0 0 0;\n    font-size: 18px;\n}\n\n.group-box .title {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.group-box .col-xl-3 {\n    margin-top: 30px;\n}\n\n.owner-dots {\n    position: absolute;\n    top: 0;\n    left: 0;\n    background-color: #727272;\n    color: #fff;\n    display: flex;\n    cursor: initial;\n    align-items: center;\n    column-gap: 10px;\n    padding: 7px 14px;\n    border-radius: 5px 0;\n}\n\n.dots {\n    position: absolute;\n    top: 0;\n    right: 0;\n    background-color: #727272;\n    display: flex;\n    cursor: pointer;\n    align-items: center;\n    column-gap: 10px;\n    padding: 7px 14px;\n    border-radius: 0 5px;\n}\n\n.img-box {\n    aspect-ratio: 16/9;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    height: 200px;\n    border-radius: 16px;\n    overflow: hidden;\n    position: relative;\n    background: #f8f9fa;\n}\n\n.img-box img {\n    object-fit: contain;\n}\n\n.tab-box-group {\n    width: 100%;\n    margin-top: 20px;\n}\n\n.tab-box-group ul {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n}\n\n.tab-box-group ul li {\n    list-style: none;\n    font-weight: 500;\n    font-size: 18px;\n    padding: 5px 0;\n    margin: 0px 25px;\n    color: #878395;\n    cursor: pointer;\n}\n\n.tab-box-group ul li.active {\n    border-top: 3px solid rgba(108, 47, 187, 1);\n    color: rgba(108, 47, 187, 1);\n}\n\n@media (max-width: 1500px) {\n    .group-box h4 {\n        font-size: 20px;\n    }\n\n    .img-box {\n        height: 172px;\n    }\n\n    .group-box .add-box {\n        height: 206px;\n    }\n}\n\n\n@media (max-width: 768px) {\n    .group-box {\n        margin-top: 10px;\n    }\n\n    .group-box h4 {\n        font-size: 18px;\n    }\n\n    .group-box {\n        padding: 10px 10px;\n        background-color: #ffff;\n    }\n\n    .add-box h5 {\n        font-size: 18px;\n    }\n\n    .group-box .add-box {\n        padding: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
